import {
  Box,
  Button,
  Card, CardContent, CardMedia,
  Chip,
  Typography,
  alpha
} from '@mui/material';
import parse from 'html-react-parser';
import { BiRightArrowAlt } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { backendURL } from 'redux/reducers/settings';
import IttImage from '../../../assets/images/file.png';

interface BlogDetails {
  id: string;
  images: string;
  title: string;
  category: string;
  description: string;
}

const CourseList = ({ id, images, title, category, description }: BlogDetails) => {
  const navigate = useNavigate();
  
  const handleRedirect = () => navigate('/course/detail/' + id);

  return (
    <Card 
      elevation={0}
      onClick={handleRedirect}
      sx={{ 
        height: '100%', 
        borderRadius: 4, 
        border: '1px solid', 
        borderColor: 'divider',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': { 
          transform: 'translateY(-8px)', 
          boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
          borderColor: 'primary.main'
        }
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          image={images === null ? IttImage : backendURL + images}
          alt={title}
          sx={{ height: 100, objectFit: 'contain' }}
        />
        <Chip 
          label={category} 
          size="small"
          sx={{ 
            position: 'absolute', top: 12, left: 12, 
            bgcolor: 'primary.main', color: 'white',
            fontWeight: 700, fontSize: '0.7rem',
            boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
          }}
        />
      </Box>

      <CardContent sx={{ p: 3, display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            fontWeight: 800, mb: 1, lineHeight: 1.4, height: 44,
            display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', 
            overflow: 'hidden' 
          }}
        >
          {title}
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ 
            mb: 3, flexGrow: 1,
            display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', 
            overflow: 'hidden', fontSize: '0.85rem'
          }}
        >
          {description ? parse(description) : 'No description provided.'}
        </Typography>

        <Box sx={{ mt: 'auto', pt: 2, borderTop: '1px solid', borderColor: alpha('#000', 0.05) }}>
           <Button 
            endIcon={<BiRightArrowAlt />} 
            sx={{ 
              p: 0, fontWeight: 800, minWidth: 0, fontSize: '0.75rem',
              color: 'primary.main', '&:hover': { bgcolor: 'transparent', letterSpacing: '1px' },
              transition: 'all 0.2s'
            }}
           >
              LEARN MORE
           </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CourseList;